import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const NAMESPACE = "downSidePanel";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
export const localStorageSettingsKey = "ohotnik.downSidePanel.settings";
export const TAB = {
    TIMELINE: "timeline",
    PRESENTATION: "presentation",
    TASKS_LOGS: "tasksLogs"
};
export const TIMELINE_RANGE_SELECTOR_MODE = {
    TIMELINE: "timeline",
    PRESENTATION: "presentation"
};
export const PRESENTATION_TEXT_FILTER_DEF_ID = "withRoundedBordersAndBackground";
export const PRESENTATION_TEXT_FILTER_DEF_ID1 = "withRoundedBordersAndBackground1";
